import { PermissionManagerFactory } from '../permissionManagerFactory';
import { INSPECTION_CRUD_PERMISSIONS } from '../inspection/inspectionPermissionManager';
import { Permission } from '../types';
import { forbid } from '../basePermissionsManager';
import { allow } from '../basePermissionsManager';

interface InspectionTemplateEditParams {
  isInspectionTemplatePublished: boolean;
  deleted?: boolean;
}

function forbidEditingInspectionTemplateIfPublished({
  isInspectionTemplatePublished,
}: InspectionTemplateEditParams): Permission {
  if (isInspectionTemplatePublished) {
    return forbid('inspection_template_edit_disabled_reason');
  }
  return allow();
}

function forbidToEditIfArchived({
  deleted,
}: InspectionTemplateEditParams): Permission {
  if (deleted) {
    return forbid('inspection_template_edit_on_archived_warning');
  }
  return allow();
}

export const InspectionTemplatePermissionManager =
  PermissionManagerFactory.create<
    void,
    InspectionTemplateEditParams,
    void
  >({
    permissionConfigForCreate: INSPECTION_CRUD_PERMISSIONS,
    permissionConfigForEdit: INSPECTION_CRUD_PERMISSIONS,
    permissionConfigForDelete: INSPECTION_CRUD_PERMISSIONS,
    businessRulesForEdit: [forbidEditingInspectionTemplateIfPublished, forbidToEditIfArchived],
  });
